import fetchIntercept, { FetchInterceptor } from 'fetch-intercept';
import { stringify } from 'querystring';

import { CustomErrorCodes, CustomExceptions, HTTPErrors } from '~/../constants/ErrorCodes';
import { GET_DISTRICT_CODE_ENDPOINT_URL } from '~/services/getDistrictCode.service';
import { RedirectError } from './errors/RedirectError';

export const CreateInterceptors = (() => {
  let instance;

  const getRelativeUrl = url => url.replace(window.location.origin, '');

  const checkRedirectionExceptions = (code, responseUrl): boolean =>
    code === HTTPErrors.notFound && responseUrl.includes(GET_DISTRICT_CODE_ENDPOINT_URL);

  const isDirectLoginDisable = (query: string, codeResponse?: string): boolean => {
    const redirectLoginDisabled = HTTPErrors.directLoginDisabled.toString();
    if (codeResponse != null) {
      return (
        query.includes(redirectLoginDisabled) &&
        codeResponse === CustomErrorCodes.directLoginDisabled
      );
    }
    return query.includes(redirectLoginDisabled);
  };

  const isTokenExpired = (query: string, codeResponse?: string): boolean => {
    const redirectTokenInvalid = HTTPErrors.tokenInvalid.toString();
    if (codeResponse != null) {
      /*  The backend response is code:'token-invalid' due to an inner exception, however it should be code:'token-expired'. this can generate confusion */
      return query.includes(redirectTokenInvalid) && codeResponse === CustomErrorCodes.tokenInvalid;
    }
    return query.includes(redirectTokenInvalid);
  };

  const isUserNotRosteredInDistrict = (query: string, codeResponse?: string): boolean => {
    const redirectuserNotRosteredInDistrict = HTTPErrors.userNotRosteredInDistrict.toString();
    if (codeResponse != null) {
      return (
        query.includes(redirectuserNotRosteredInDistrict) &&
        codeResponse === CustomErrorCodes.userNotRosteredInDistrict
      );
    }
    return query.includes(redirectuserNotRosteredInDistrict);
  };
  interface ExtendedFetchInterceptor extends FetchInterceptor {
    response?(response: any): any;
  }
  const init = () => ({
    registerInterceptors: () => {
      fetchIntercept.register({
        async response(response) {
          const code = response.status;
          const errorType = response.headers
            .get('x-amzn-errortype')
            ?.toString()
            .replace(':', '');
          const customExceptions: string[] = Object.values(CustomExceptions);
          if (
            code >= HTTPErrors.badRequest &&
            !checkRedirectionExceptions(code, getRelativeUrl(response.url)) &&
            !customExceptions.includes(errorType)
          ) {
            const responseBody = await response.json();
            const responseBodyCode = responseBody.code;
            const spanId = response.headers.get('x-spanid')?.toString();
            const traceId = response.headers.get('x-traceid')?.toString();
            const query = stringify(spanId || traceId ? { code, spanId, traceId } : { code });
            const queryParamToAddInRedirectErrors = stringify({
              /*  This is a WORKAROUND: We manually define the code 'token-expired' and add it as query param because the BE response still 'token-invalid', ideally on the BE side we get 'token-expired' and avoid this isTokenExpired condition. */
              code: isTokenExpired(query, responseBodyCode) ? 'token-expired' : responseBodyCode,
            });

            const queryToRedirect =
              isDirectLoginDisable(query, responseBodyCode) ||
              isTokenExpired(query, responseBodyCode) ||
              isUserNotRosteredInDistrict(query, responseBodyCode)
                ? queryParamToAddInRedirectErrors
                : query;

            window.location.href = `${window.location.origin}/login/error?${queryToRedirect}`;

            return Promise.reject(new RedirectError()) as any;
          }
          return response;
        },
      } as ExtendedFetchInterceptor);
    },
  });

  return {
    getInstance() {
      if (!instance) {
        instance = init();
      }
      return instance;
    },
  };
})();
